import { render, staticRenderFns } from "./CRUDChecklistEquipamento.vue?vue&type=template&id=2daa145e&scoped=true&"
import script from "./CRUDChecklistEquipamento.vue?vue&type=script&lang=js&"
export * from "./CRUDChecklistEquipamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2daa145e",
  null
  
)

export default component.exports